import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import {
    SpsWorkflowComponent,
    SpsWorkflowStepComponent,
    SpsWorkflowDocumentComponent,
    SpsWorkflowDocumentStatusComponent,
} from "../components/index";

@NgModule({
    imports: [CommonModule],
    declarations: [
        SpsWorkflowComponent,
        SpsWorkflowStepComponent,
        SpsWorkflowDocumentComponent,
        SpsWorkflowDocumentStatusComponent
    ],
    exports: [
        SpsWorkflowComponent,
        SpsWorkflowStepComponent,
        SpsWorkflowDocumentComponent,
        SpsWorkflowDocumentStatusComponent
    ]
})
export class SpsWorkflowModule {}
